import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { auth } from "../../redux";
import { fetchSsoAuthenticated, isSsoEnabled } from "../../utils/sso";

const POLL_MS = 20000;
const SKIP_PREFIXES = ["/sso/callback"];

function shouldSkipPath(pathname) {
  return SKIP_PREFIXES.some((prefix) => pathname.indexOf(prefix) === 0);
}

function publicPath(centerCostId) {
  if (centerCostId) {
    return `/offers-unique/${centerCostId}`;
  }
  return "/offers";
}

function SsoSessionWatch() {
  const dispatch = useDispatch();
  const history = useHistory();
  const isAuthenticated = useSelector((state) => state.auth.isAutenticated);
  const centerCostId = useSelector((state) => state.auth.cc);
  const expiring = useRef(false);

  const expireLocal = useCallback(() => {
    if (expiring.current) {
      return;
    }
    expiring.current = true;
    dispatch(auth.actions.expireLocalSession());
    history.replace(publicPath(centerCostId));
  }, [centerCostId, dispatch, history]);

  useEffect(() => {
    if (!isSsoEnabled() || !isAuthenticated) {
      return undefined;
    }

    let cancelled = false;

    async function checkSession() {
      if (cancelled || expiring.current) {
        return;
      }
      if (document.visibilityState === "hidden") {
        return;
      }
      if (shouldSkipPath(window.location.pathname)) {
        return;
      }

      try {
        const authenticated = await fetchSsoAuthenticated();
        if (cancelled || authenticated === null) {
          return;
        }
        if (authenticated !== true) {
          expireLocal();
        }
      } catch (error) {
        return;
      }
    }

    checkSession();
    const intervalId = window.setInterval(checkSession, POLL_MS);
    document.addEventListener("visibilitychange", checkSession);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", checkSession);
    };
  }, [expireLocal, isAuthenticated]);

  return null;
}

export default SsoSessionWatch;
